import Moment from './Moment.js'

export default (Vue) => {
  Vue.filter('moment', Moment)
}



// WEBPACK FOOTER //
// ./src/filters/index.js